import React from 'react';
import { mountCrmQuiz } from '../quiz/crmQuizApp.jsx';
import { mountCrmQuizQuestionnaireForm } from '../quiz/crmQuizQuestionnaireForm.jsx';

window.React = React;

document.addEventListener('DOMContentLoaded', mountCrmQuiz);
document.addEventListener('DOMContentLoaded', mountCrmQuizQuestionnaireForm);
